import { render, staticRenderFns } from "./ComentariosPagos.vue?vue&type=template&id=954ace60&"
import script from "./ComentariosPagos.vue?vue&type=script&lang=js&"
export * from "./ComentariosPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports